import { configureStore } from "@reduxjs/toolkit";
import teacherSubReducer from "../features/teachersubject/teacherSubSlice"
import examTemplateReducer from "../features/examTemplate/examTemplateSlice"

export const store = configureStore({
    reducer:{
        teacherSub: teacherSubReducer,
        examTemplate: examTemplateReducer
    }
})
